import type { UpdateClaimAccessRequestBlockedModulesEnum } from "@/api/generated/client/models";

export const LOSS_TYPE_OPTIONS = [
    { value: "fire", label: "Fire" },
    { value: "water", label: "Water" },
    { value: "wind", label: "Wind" },
    { value: "hail", label: "Hail" },
    { value: "theft", label: "Theft" },
    { value: "other", label: "Other" },
];

export const LOSS_TYPE_VALUES = new Set(LOSS_TYPE_OPTIONS.map(o => o.value));

export const CLAIM_MODULE_OPTIONS = [
    { value: "comparisons", label: "Comparisons" },
    { value: "documents", label: "Documents" },
    { value: "photos", label: "Photos" },
    { value: "links", label: "Links" },
    { value: "tasks", label: "Tasks" },
    { value: "supplements", label: "Supplements" },
    { value: "forms", label: "Forms" },
    { value: "financials", label: "Financials" },
    { value: "emails", label: "Email" },
    { value: "notes", label: "Notes" },
] as const satisfies ReadonlyArray<{
    value: UpdateClaimAccessRequestBlockedModulesEnum;
    label: string;
}>;

export type ClaimModuleKey = (typeof CLAIM_MODULE_OPTIONS)[number]["value"];

export const CLAIM_MODULE_VALUES = new Set<ClaimModuleKey>(CLAIM_MODULE_OPTIONS.map((option) => option.value));
